export const getData = state => state.reportVehicleFuelings.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleFuelings.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleFuelings.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleFuelings.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleFuelings.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleFuelings.getIn(['details', 'error'])
